"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var reconnect_js_1 = require("reconnect.js");
var ChevronUp_1 = require("@styled-icons/entypo/ChevronUp");
function cls(arr) {
  return arr.filter(function (item) {
    return typeof item === 'string';
  }).join(' ');
}
function FilterMenuL2(props) {
  var cat = props.cat,
    updateCat = props.updateCat,
    _a = props.mobile,
    mobile = _a === void 0 ? false : _a;
  var categories = (0, reconnect_js_1.useOutlet)(props.categories)[0];
  return react_1.default.createElement(Wrapper, {
    className: cls(['rev-FilterMenuL2', mobile && 'mobile'])
  }, react_1.default.createElement("div", {
    className: "header"
  }, react_1.default.createElement("div", {
    className: "label",
    onClick: function () {
      return updateCat('');
    }
  }, "\u7522\u54C1\u5206\u985E")), categories.map(function (catL1) {
    return react_1.default.createElement(TopLevelCategory, {
      key: catL1.name,
      catL1: catL1,
      cat: cat,
      updateCat: updateCat
    });
  }));
}
exports.default = FilterMenuL2;
function TopLevelCategory(props) {
  var catL1 = props.catL1,
    cat = props.cat,
    updateCat = props.updateCat;
  var _a = (cat || '').split('-'),
    currL1 = _a[0],
    currL2 = _a[1];
  var selected = currL1 === catL1.name;
  var _b = react_1.default.useState(selected),
    expand = _b[0],
    setExpand = _b[1];
  return react_1.default.createElement(CatL1Wrapper, {
    className: cls(['L1', selected && 'selected']),
    expand: expand
  }, react_1.default.createElement("div", {
    className: "header"
  }, react_1.default.createElement("div", {
    className: "label",
    onClick: function () {
      return updateCat(catL1.name);
    }
  }, catL1.display || catL1.name), react_1.default.createElement("div", {
    className: "icon",
    onClick: function (e) {
      e.stopPropagation();
      setExpand(!expand);
    }
  }, react_1.default.createElement(ChevronUp_1.ChevronUp, {
    size: 18
  }))), Array.isArray(catL1.items) && catL1.items.length > 0 && react_1.default.createElement("div", {
    className: "L1-items"
  }, catL1.items.map(function (catL2) {
    var selected = catL2.name === "".concat(currL1, "-").concat(currL2);
    return react_1.default.createElement("div", {
      className: cls(['L2', selected && 'selected']),
      key: catL2.name
    }, react_1.default.createElement("div", {
      className: "header",
      key: catL2.name,
      onClick: function () {
        return updateCat(catL2.name);
      }
    }, react_1.default.createElement("div", null, catL2.display || catL2.name)));
  })));
}
var CatL1Wrapper = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  background-color: white;\n  border-radius: 12px;\n  padding: 10px;\n  margin-bottom: 20px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);\n\n  &.selected > .header {\n    color: black;\n  }\n\n  & > .header {\n    display: flex;\n    align-items: center;\n    font-size: 1.2rem;\n    color: #888;\n\n    & > .label {\n      flex: 1;\n      cursor: pointer;\n      line-height: 40px;\n    }\n\n    & > .icon {\n      transition: all 250ms;\n      transform: rotateX(", ");\n      cursor: pointer;\n    }\n  }\n\n  & > .L1-items {\n    max-height: ", ";\n    opacity: ", ";\n    transition: all 250ms;\n    border-top: 1px solid #aaa;\n\n    & > .L2 {\n      margin: 15px 0;\n      color: #aaa;\n      font-size: 1rem;\n      cursor: pointer;\n    }\n\n    & > .L2.selected > .header {\n      color: black;\n    }\n  }\n"], ["\n  background-color: white;\n  border-radius: 12px;\n  padding: 10px;\n  margin-bottom: 20px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);\n\n  &.selected > .header {\n    color: black;\n  }\n\n  & > .header {\n    display: flex;\n    align-items: center;\n    font-size: 1.2rem;\n    color: #888;\n\n    & > .label {\n      flex: 1;\n      cursor: pointer;\n      line-height: 40px;\n    }\n\n    & > .icon {\n      transition: all 250ms;\n      transform: rotateX(", ");\n      cursor: pointer;\n    }\n  }\n\n  & > .L1-items {\n    max-height: ", ";\n    opacity: ", ";\n    transition: all 250ms;\n    border-top: 1px solid #aaa;\n\n    & > .L2 {\n      margin: 15px 0;\n      color: #aaa;\n      font-size: 1rem;\n      cursor: pointer;\n    }\n\n    & > .L2.selected > .header {\n      color: black;\n    }\n  }\n"])), function (props) {
  return props.expand ? '180deg' : '0deg';
}, function (props) {
  return props.expand ? '1000px' : '0px';
}, function (props) {
  return props.expand ? 1 : 0;
});
var Wrapper = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  width: 200px;\n\n  position: sticky;\n  top: var(--topNavBarHeight);\n\n  & > .header {\n    padding: 15px 10px;\n    display: flex;\n    align-items: center;\n\n    & > .label {\n      flex: 1;\n      font-size: 1.3rem;\n      cursor: pointer;\n    }\n  }\n\n  &.mobile {\n    padding: 0 8px;\n  }\n"], ["\n  width: 200px;\n\n  position: sticky;\n  top: var(--topNavBarHeight);\n\n  & > .header {\n    padding: 15px 10px;\n    display: flex;\n    align-items: center;\n\n    & > .label {\n      flex: 1;\n      font-size: 1.3rem;\n      cursor: pointer;\n    }\n  }\n\n  &.mobile {\n    padding: 0 8px;\n  }\n"])));
var templateObject_1, templateObject_2;